module.exports = __webpack_public_path__ + "static/media/porsche.6182f421.png";